import {
  EnderecoDtoCreate,
  EnderecoDtoUpdate,
  EnderecoList,
  EnderecoView,
} from 'app/modules/apps/empresa/empresas-list/core/_models'
import axios, { AxiosResponse } from 'axios'

const API_URL = process.env.REACT_APP_API_URL

const USUARIO_ENDERECO_URL = `${API_URL}/enderecos/me`

/**
 * Busca endereços do usuário autenticado
 * @returns EnderecoList[]
 */
export const getEnderecosUsuarioAutenticado = (): Promise<EnderecoList[]> => {
  return axios.get(USUARIO_ENDERECO_URL).then((resp: AxiosResponse<EnderecoList[]>) => resp.data)
}

/**
 * Altera um endereço do usuário autenticado
 * @param data EnderecoDtoUpdate
 * @returns EnderecoView
 */
export const updateEnderecoUsuarioAutenticado = (
  data: EnderecoDtoUpdate
): Promise<EnderecoView> => {
  return axios
    .put(USUARIO_ENDERECO_URL, data)
    .then((resp: AxiosResponse<EnderecoView>) => resp.data)
}

/**
 * Altera um endereço do usuário autenticado
 * @param data EnderecoDtoCreate
 * @returns EnderecoView
 */
export const createEnderecoUsuarioAutenticado = (
  data: EnderecoDtoCreate
): Promise<EnderecoView> => {
  return axios
    .post(USUARIO_ENDERECO_URL, data)
    .then((resp: AxiosResponse<EnderecoView>) => resp.data)
}
